import { Component, OnInit } from '@angular/core';
import { TourNavigationService } from '../services/tour-navigation.service';
import { debug } from 'util';

@Component({
  selector: 'app-information-tour',
  templateUrl: './information-tour.component.html',
  styleUrls: ['./information-tour.component.scss']
})
export class InformationTourComponent implements OnInit {

  isTourActive = false;

  instruction = [
    {
      index: 1,
      title: 'First, create a deck',
      text: 'Choose a basic deck shape and customize with our shaping tools. Set the height, add tiers and/or stairs, adjacent walls, scenery, and accessories.',
      next: 2,
      back: 0,
      class: 'tour-visualization-1',
    },
    {
      index: 2,
      title: 'Then build your railing',
      text: 'Choose your railing type, and edit railing features such as post mounting, infill and color.',
      next: 3,
      back: 1,
      class: 'tour-visualization-2',
    },
    {
      index: 3,
      title: 'Manage your projects',
      text: 'Save your current project, share and print your project, and access previous projects.',
      next: 4,
      back: 2,
      class: 'tour-visualization-3',
    },
    {
      index: 4,
      title: 'Viewing Tools',
      text: 'Easily switch between 3D and 2D views of your deck project. Change the lighting to see how the deck and railing change during the day or simply snap a screen shot.',
      next: 5,
      back: 3,
      class: 'tour-visualization-4',
    },
    {
      index: 5,
      title: 'Settings and Help',
      text: 'Looking for answers? Need to change the unit of measure or other settings? Look here.',
      next: 6,
      back: 4,
      class: 'tour-visualization-5',
    },
    {
      index: 6,
      title: 'Perspective Controls',
      text: 'Change the viewing angle in 3D mode, zoom and pan to see your deck from multiple angles.',
      next: 7,
      back: 5,
      class: 'tour-visualization-6',
    },
    {
      index: 7,
      title: 'Next steps',
      text: 'Share, print, and save your project. Click GET A QUOTE to send your project to the local Feeney dealer of your choice.',
      next: 0,
      back: 6,
      class: 'tour-visualization-7',
    },
  ];
  currentTour = this.instruction[0];

  openTour = function () {
    this.isTourActive = true;

  };

  gotoTour = function (tourIndex) {
    this.isTourActive = true;
    this.tourNavigationService.changeTourStep(tourIndex);

  };

  gotoBack = function () {
    let index = this.currentTour.back;
    // this.dropTour();

    this.tourNavigationService.changeTourStep(index);
  };

  gotoNext = function () {
     let index = this.currentTour.next;
    //  this.dropTour();

    this.tourNavigationService.changeTourStep(index);
  };

  closeTour = function () {
    this.isTourActive = false;
    this.currentTour = {};

    setTimeout(function () {
      (<any>$('#step_1')).addClass('active');
      (<any>$('#step_1')).removeClass('border-shadow no-left-half hide-top-border');
      (<any>$('.step_1_top')).removeClass('border-shadow hide-bottom-border');
      (<any>$('#step_2')).removeClass('active border-shadow no-right-half hide-top-border');
      (<any>$('.step_2_top')).removeClass('active border-shadow hide-bottom-border');
      (<any>$('.step_3')).removeClass('border-shadow hide-bottom-border');
      (<any>$('.step_3_dm')).removeClass('border-shadow project-menu hide-top-border');
      (<any>$('.step_4')).removeClass('border-shadow');
      (<any>$('.step_5')).removeClass('border-shadow');
      (<any>$('.step_6')).removeClass('border-swadow-controls');
      (<any>$('.step_7')).removeClass('border-shadow');
    }, 0);

  };

  constructor(public tourNavigationService: TourNavigationService) {}

  ngOnInit() {
    this.tourNavigationService.Navigator.subscribe(
      value => {
        // console.log(value);
        this.isTourActive = true;
        this.currentTour = this.instruction[value - 1];

        if (value === 3) {
          setTimeout(function () {
            (<any>$('.manage-project')).dropdown('toggle');
          }, 0);
        } else if (value === 4) {
          setTimeout(function () {
            (<any>$('#bright-control')).dropdown('toggle');
          }, 0);
        } else if (value === 2) {
          setTimeout(function () {
            (<any>$('#step_1')).removeClass('active');
          }, 0);
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/information-tour/information-tour.component.ts